import { initDimensionUtils } from '../../commons/utils/dimensions';

const REFERENCE_SCREEN_WIDTH = 1920.0;
const REFERENCE_SCREEN_HEIGHT = 1080.0;

const screenUtils = initDimensionUtils(REFERENCE_SCREEN_WIDTH, REFERENCE_SCREEN_HEIGHT);

export const { refWidth, refWidthCalc, refHeight, refFontSizeCalc, refFontSize } = screenUtils;
